import React, { useEffect, useState } from 'react';
import 'twin.macro';
import { SchoolDatePicker } from '@teetsh/app/src/components/Form/DatePicker/SchoolDatePicker';
import { format } from '@teetsh/app/src/utils/time/format';
import { isoDatePatternWithSlashes } from '@teetsh/app/src/utils/time/datePatterns';
import { getInitialDate } from '@teetsh/app/src/containers/CahierJournal/Toolbar/DateNavigator/getInitialDate';
import { useGetDaysWithEvents } from '@teetsh/app/src/containers/CahierJournal/queries/useGetDaysWithEvents';
import { CahierJournalView } from '@teetsh/app/src/containers/CahierJournal/types';
import usePopoverContext from '@teetsh/app/src/components/Popover/usePopoverContext';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import { useCahierJournalGoTo } from '@teetsh/app/src/containers/App/useCahierJournalGoTo';

interface Props {
  workingDays: number[];
  view: CahierJournalView;
  date: Date;
}

export function Body(props: Props) {
  const { workingDays, view } = props;
  const { locale } = useUser();
  const { data } = useGetDaysWithEvents();
  const { refs } = usePopoverContext();
  const goTo = useCahierJournalGoTo();
  const [date, setDate] = useState<Date>(
    getInitialDate(new Date(), props.date, workingDays, view),
  );
  useEffect(() => {
    setDate(getInitialDate(new Date(), props.date, workingDays, view));
  }, [props.date, JSON.stringify(workingDays), view]);
  const sundayStart = workingDays.includes(-1);
  const close = () => {
    const buttonToClick = refs?.reference?.current;
    if (buttonToClick) {
      buttonToClick.click();
    }
  };

  return (
    <div tw="text-center pb-3">
      <div tw="mb-3">
        <SchoolDatePicker
          mode="single"
          userLocale={locale}
          sundayStart={sundayStart}
          value={date}
          dots={data || []}
          onChange={v => {
            if (v) {
              close();
              goTo(
                `cahier-journal/${view}/${format(
                  v,
                  'fr-FR',
                  isoDatePatternWithSlashes,
                )}`,
              );
            }
          }}
        />
      </div>
    </div>
  );
}
